// @flow
import React, { Component } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Text } from 'trpc-react-native-ui';

import CameraWrapper from '../../../utils/cameraWrapper'; 

import { Icon } from '../../../components/common';
import I18n from '../../../lib/i18n';

import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';

type Props = {
  changeFormFieldValue: Function,
  isFocused: boolean,
  navigation: NavigationScreenProp<NavigationRoute>,
  submitForm: Function,
};

type State = {
  isCameraActive: boolean,
  helpTooLongVisible: boolean,
};

export default class SIMCardScan extends Component<Props, State> {
  state = {
    isCameraActive: true,
    helpTooLongVisible: false,
  };

  isScanning = false; 
  helpTooLongVisibleTimeout: any = undefined;

  // 1. Define the Scanner Configuration
  // This replaces the 'onBarCodeRead' prop from RNCamera
  codeScanner = {
    codeTypes: ['code-128', 'ean-13', 'itf', 'code-39'], // Standard SIM barcode types
    onCodeScanned: (codes: any[]) => {
      // Vision Camera is very fast; we must check isCameraActive to prevent multiple triggers
      if (!this.isScanning && this.state.isCameraActive && codes.length > 0) {
        const scannedData = codes[0].value;
        if (scannedData) {
          this.isScanning = true;
          this.saveMeterID(scannedData);
        }
      }
    }
  };

  saveMeterID = (data: string) => {
    // Disable camera immediately to show the "Check" overlay and stop scanning
    this.setState({ isCameraActive: false }, () => {
      this.props.changeFormFieldValue('SIMCard', 'number', data);
      
      setTimeout(() => {
        if (this.props.navigation.isFocused()) {
          this.props.navigation.goBack();
          this.props.submitForm('SIMCard');
        }
      }, 400);
    });
  };

  componentDidMount() {
    this.helpTooLongVisibleTimeout = setTimeout(() => {
      this.setState({ helpTooLongVisible: true });
    }, 10000);
  }

  componentWillUnmount() {
    if (this.helpTooLongVisibleTimeout) {
      clearTimeout(this.helpTooLongVisibleTimeout);
    }
  }

  render() {
    return (
      <View style={styles.container}>
        {/* 2. Using the new CameraWrapper instead of RNCamera */}
        {this.props.isFocused && (
          <CameraWrapper
            isActive={this.state.isCameraActive}
            codeScanner={this.codeScanner}
            deviceType="back"
          />
        )}

        {!this.state.isCameraActive ? (
          <View style={[styles.overlaysContainer, styles.overlay, styles.checkIconContainer]}>
            <View style={styles.checkIcon}>
              <Icon name="check" size={35} color="white" />
            </View>
          </View>
        ) : (
          <View style={styles.overlaysContainer}>
            <View style={styles.overlaysContainer}>
              <View style={[styles.overlay, { flex: 5 }]} />
              <View style={[styles.horizontalOverlayContainer, { flex: 3 }]}>
                <View style={[styles.overlay, { flex: 1 }]} />
                <View style={[styles.rectangleContainer, { flex: 10 }]}>
                  <View style={[styles.rectangle, { borderRightWidth: 0 }]} />
                  <View style={[styles.rectangle, { borderLeftWidth: 0 }]} />
                </View>
                <View style={[styles.overlay, { flex: 1 }]} />
              </View>
              <View style={[styles.overlay, { flex: 5 }]} />
            </View>
          </View>
        )}

        <View style={styles.helpContainer}>
          <View style={styles.helpContainerElement}>
            <Text style={styles.helpText}>{I18n.t('SignUp.SIMCardManual.helpText')}</Text>
          </View>
          <View style={styles.helpContainerElement} />
          <View style={styles.helpContainerElement}>
            {this.state.helpTooLongVisible && (
              <Text style={styles.helpText}>{I18n.t('SignUp.SIMCardManual.tooLongHelpText')}</Text>
            )}
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'black',
  },
  helpContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingHorizontal: 50,
  },
  helpContainerElement: {
    justifyContent: 'center',
    flex: 1,
  },
  helpText: {
    backgroundColor: 'transparent',
    textAlign: 'center',
    color: 'white',
    fontSize: 16,
  },
  overlaysContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  horizontalOverlayContainer: {
    flexDirection: 'row',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  rectangleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  rectangle: {
    padding: '2%',
    borderColor: 'white',
    borderWidth: 3,
    width: '48%', // Ensure rectangles have some width to show the "corners"
  },
  checkIconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkIcon: {
    width: 70,
    height: 70,
    borderWidth: 7,
    borderColor: 'white',
    borderRadius: 70,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
});